

/* eslint-disable wrap-iife */
// Older browsers support
import "core-js/modules/es6.typed.array-buffer";
import "core-js/modules/es6.typed.int8-array";
import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.typed.uint8-clamped-array";
import "core-js/modules/es6.typed.int16-array";
import "core-js/modules/es6.typed.uint16-array";
import "core-js/modules/es6.typed.int32-array";
import "core-js/modules/es6.typed.uint32-array";
import "core-js/modules/es6.typed.float32-array";
import "core-js/modules/es6.typed.float64-array";
import "core-js/modules/es6.map";
import "core-js/modules/es6.set";
import "core-js/modules/es6.weak-map";
import "core-js/modules/es6.weak-set";
import "core-js/modules/es6.reflect.apply";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.reflect.define-property";
import "core-js/modules/es6.reflect.delete-property";
import "core-js/modules/es6.reflect.get";
import "core-js/modules/es6.reflect.get-own-property-descriptor";
import "core-js/modules/es6.reflect.get-prototype-of";
import "core-js/modules/es6.reflect.has";
import "core-js/modules/es6.reflect.is-extensible";
import "core-js/modules/es6.reflect.own-keys";
import "core-js/modules/es6.reflect.prevent-extensions";
import "core-js/modules/es6.reflect.set";
import "core-js/modules/es6.reflect.set-prototype-of";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.freeze";
import "core-js/modules/es6.object.seal";
import "core-js/modules/es6.object.prevent-extensions";
import "core-js/modules/es6.object.is-frozen";
import "core-js/modules/es6.object.is-sealed";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.get-own-property-descriptor";
import "core-js/modules/es6.object.get-prototype-of";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.get-own-property-names";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.raw";
import "core-js/modules/es6.string.from-code-point";
import "core-js/modules/es6.string.code-point-at";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.flags";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.of";
import "core-js/modules/es6.array.copy-within";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.number.is-finite";
import "core-js/modules/es6.number.is-integer";
import "core-js/modules/es6.number.is-safe-integer";
import "core-js/modules/es6.number.is-nan";
import "core-js/modules/es6.number.epsilon";
import "core-js/modules/es6.number.min-safe-integer";
import "core-js/modules/es6.number.max-safe-integer";
import "core-js/modules/es6.math.acosh";
import "core-js/modules/es6.math.asinh";
import "core-js/modules/es6.math.atanh";
import "core-js/modules/es6.math.cbrt";
import "core-js/modules/es6.math.clz32";
import "core-js/modules/es6.math.cosh";
import "core-js/modules/es6.math.expm1";
import "core-js/modules/es6.math.fround";
import "core-js/modules/es6.math.hypot";
import "core-js/modules/es6.math.imul";
import "core-js/modules/es6.math.log1p";
import "core-js/modules/es6.math.log10";
import "core-js/modules/es6.math.log2";
import "core-js/modules/es6.math.sign";
import "core-js/modules/es6.math.sinh";
import "core-js/modules/es6.math.tanh";
import "core-js/modules/es6.math.trunc";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es7.object.values";
import "core-js/modules/es7.object.entries";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es7.string.pad-start";
import "core-js/modules/es7.string.pad-end";
import "core-js/modules/web.timers";
import "core-js/modules/web.immediate";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");
import 'es6-promise/auto';
import 'formdata-polyfill';
import 'url-polyfill';

// Theme SCSS files
import '../../styles/theme.scss';
import '../../styles/theme.scss.liquid';

// Vue.js core
import Vue from 'vue';

// Bootstrap Framework
import 'bootstrap';

// Bootstrap-Vue
// import BootstrapVue from 'bootstrap-vue' // imports all library
// for better performance you can import individual components
import bPopover from 'bootstrap-vue/es/components/popover/popover';

// Local Storage
import Storage from 'vue-web-storage';

// Spinners
// https://epic-spinners.epicmax.co/#/get-started
import 'epic-spinners/dist/lib/epic-spinners.min.css';
import { HollowDotsSpinner } from 'epic-spinners/dist/lib/epic-spinners.min.js';

// Other libraries
import Vue2TouchEvents from 'vue2-touch-events';
import Snotify from 'vue-snotify';
import VueMatchHeights from 'vue-match-heights';
import VueInstagram from 'vue-instagram';

// allow inline javascript code to be executed by using '<script2></script2>' tag
import VueScript2 from 'vue-script2';

// Lazysizes plugin for lazyloading
import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'; // bg images support extension
import 'lazysizes/plugins/bgset/ls.bgset'; // responsive bg images support extension
import 'lazysizes/plugins/parent-fit/ls.parent-fit'; // parent fit extension

// Store => common data objects
import store from '../store/store';

// mixins
import helperMethods from '../mixins/helpers';
import layoutMethods from '../mixins/layout';
import cartMethods from '../mixins/cart';
import productMethods from '../mixins/product';
import accountMethods from '../mixins/account';
import wishlistMethods from '../mixins/wishlist';
import productReviewsMethods from '../mixins/productReviews';
import sectionMethods from '../mixins/section';
import storeUtilitiesMethods from '../mixins/storeUtilities';
import customMethods from '../mixins/custom';

var app = void 0;

// register components in Vue
Vue.use(VueScript2);
// Vue.use(BootstrapVue);
Vue.use(Vue2TouchEvents);
Vue.use(VueMatchHeights);
Vue.use(VueInstagram);

Vue.use(Snotify, {
	global: {
		preventDuplicates: true
	},
	toast: {
		position: 'rightTop'
	}
});

Vue.use(Storage, {
	drivers: ['session', 'local'] // default 'local'
});

// Create new Vue instance
new Vue({
	el: '#app',
	delimiters: ['${', '}'],

	components: {
		bPopover: bPopover,
		HollowDotsSpinner: HollowDotsSpinner
	},

	mixins: [helperMethods, layoutMethods, cartMethods, productMethods, accountMethods, wishlistMethods, productReviewsMethods, sectionMethods, storeUtilitiesMethods, customMethods],

	data: function data() {
		return store; // shared data
	},
	beforeCreate: function beforeCreate() {
		$('.shopify-challenge__container').detach().appendTo('[data-app-scripts]');
		$('#additional-checkout-buttons iframe').addClass('d-none').detach().appendTo('[data-app-scripts]');
		$('#app script:not([type="application/json"])').each(function () {
			$(this).detach().appendTo('[data-app-scripts]');
		});
		$('#app style').each(function () {
			$(this).detach().appendTo('[data-app-styles]');
		});
	},
	mounted: function mounted() {
		app = this;
		window.app = app;
		window.slate = window.slate || {};
		window.theme = window.theme || {};
		// $(window).on('load', app._initTheme);
		window.onload = function () {
			setTimeout(function () {
				if (app.currentTemplate !== 'index') {
					var script = void 0;
					if (app.currentTemplate !== 'index') {
						script = document.createElement('script');
						script.type = 'text/javascript';
						script.defer = true;
						script.async = true;
						script.src = 'https://formbuilder.hulkapps.com/skeletopapp.js?shop=riverbendhomedev.myshopify.com';
						document.getElementsByTagName('head')[0].appendChild(script);
					}
					script = document.createElement('script');
					script.type = 'text/javascript';
					script.defer = true;
					script.async = true;
					script.src = 'https://cdn1.stamped.io/files/widget.min.js?shop=riverbendhomedev.myshopify.com';
					document.getElementsByTagName('head')[0].appendChild(script);

					if (app.currentTemplate !== 'product' || app.currentTemplate !== 'collections') {
						script = document.createElement('script');
						script.type = 'text/javascript';
						script.defer = true;
						script.async = true;
						script.src = 'https://d11gyepaze0qmc.cloudfront.net/assets/js/order-lookup-by-hulkapps.js?shop=riverbendhomedev.myshopify.com';
						document.getElementsByTagName('head')[0].appendChild(script);

						script = document.createElement('script');
						script.type = 'text/javascript';
						script.defer = true;
						script.async = true;
						script.src = 'https://cdn.swellrewards.com/loader/HJLxyy6qVs2wejsoVbUK4g.js?shop=riverbendhomedev.myshopify.co';
						document.getElementsByTagName('head')[0].appendChild(script);
					}
				}
			}, 10000);
		};
		$(document).ready(function () {
			app._initTheme();
		});
	},


	methods: {
		_initTheme: function _initTheme() {
			$('.site-footer').show();
			$('html').removeClass('wf-loading');
			// call helper function
			app._getCurrentTemplate();
			var temp = app.currentTemplate;

			// initialization methods
			app._initLayout(); // various functions related to layout, e.g. initialize Bootstrap specific components etc
			app._initCart(); // everything cart related, e.g. add product to cart etc
			// app._initCollection(); // everything related to the collection pages, e.g. collection filtering etc
			if (temp === 'product') {
				app._initProduct(); // everything related to the product page, e.g. variant selection, product options, galleries etc
			}
			if (temp === 'account') {
				app._initAccount(); // everything related to the user account page, login, register etc
			}
			app._initWishlist(); // wishlist functionality
			app._initSection(); // Shopify admin sections & blocks => interaction between theme JavaScript and the theme editor
			app._initStoreUtilities(); // methods for the store utilities app
			app._initCustomMethods(); // custom JS code

			if (temp === 'product' || temp === 'all-reviews') {
				app._initProductReviews(); // product reviews functionality
			}

			$('[data-emptyWishlist]').show();
		}
	}
});